import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"

import { API_STATUS } from "../types"
import { clearModelSettings, fetchModelSettings } from "../utilities/actions"
import { INITIAL_ISSUER_STATE } from "../../constants/supervisory"

import { ACTION_TYPE_PARENT, fetchListOfProducts, setSelectedIssuer, setSelectedProduct } from "./actions"
import { productSliceInitialState } from "./types"

const INITIAL_STATE: productSliceInitialState = {
  originalProductModelSchema: [],
  listOfProductsForIssuer: [],
  status: API_STATUS.idle,
  isLoading: false,
  error: null,
  selectedIssuer: INITIAL_ISSUER_STATE,
  selectedProduct: null
}

/* eslint-disable no-param-reassign */
export const productSlice = createSlice({
  name: ACTION_TYPE_PARENT,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchModelSettings.fulfilled, (state, action: PayloadAction<string[]>) => {
        state.status = API_STATUS.success
        state.originalProductModelSchema = [...state.originalProductModelSchema, ...action.payload]
      })
      .addCase(fetchModelSettings.pending, (state) => {
        state.status = API_STATUS.loading
      })
      .addCase(fetchModelSettings.rejected, (state, action: any) => {
        state.status = API_STATUS.failed
        // state.error = action?.error?.message
        state.error = action.payload
      })
      .addCase(clearModelSettings.fulfilled, (state, action: any) => {
        state.status = API_STATUS.success
        state.originalProductModelSchema = action.payload
      })
      .addCase(fetchListOfProducts.fulfilled, (state, action: PayloadAction<string[]>) => {
        state.status = API_STATUS.success
        state.listOfProductsForIssuer = action.payload
      })
      .addCase(fetchListOfProducts.pending, (state) => {
        state.status = API_STATUS.loading
      })
      .addCase(fetchListOfProducts.rejected, (state, action: any) => {
        state.status = API_STATUS.failed
        state.error = action.payload
      })
      .addCase(setSelectedIssuer.fulfilled, (state, action: any) => {
        state.status = API_STATUS.success
        state.selectedIssuer = action.payload
      })
      .addCase(setSelectedIssuer.pending, (state) => {
        state.status = API_STATUS.loading
      })
      .addCase(setSelectedIssuer.rejected, (state, action: any) => {
        state.status = API_STATUS.failed
        state.error = action.payload
      })
      .addCase(setSelectedProduct.fulfilled, (state, action: any) => {
        state.status = API_STATUS.success
        state.selectedProduct = action.payload
      })
      .addCase(setSelectedProduct.pending, (state) => {
        state.status = API_STATUS.loading
      })
      .addCase(setSelectedProduct.rejected, (state, action: any) => {
        state.status = API_STATUS.failed
        state.error = action.payload
      })
  }
})
/* eslint-disable no-param-reassign */

// export const { } = organizationSlice.actions

export default productSlice.reducer

// export const selectedAllOrganizations = (state: RootState) => state[ACTION_TYPE_PARENT].organizationList
